import { feedConstants as fc } from 'srcReact/FeedPage'

const initialState = {
  group: {
    id: '',
    loaded: false,
    loading: true,
    error: false,
    name: '',
    description: '',
    gmt_creation_date: '',
    members_number: 0,
    automatic_approval_to_join: 0,
    privacy_setting: 'public',
    is_general: 0,
    interests: [],
    totalUsersInGroup: [],
    workplace: {
      id: '',
      name: '',
      color: '',
      initials: ''
    },
    logged_user: {
      group_attending: 'none',
      group_role: 'none',
      can_plan_mixr: 0,
      can_suggest_mixr: 0
    },
    featured_files: { pictures: [], documents: [] },
    organizer: {
      user_id: '',
      display_name: '',
      picture_url: ''
    },
    picture: {
      path: ''
    }
  },

  moderation_info: {
    flagged_posts: 0
  },
  membersLoading: false,
  users: [],
  usersStat: null,
  searchMember: '',
  searchedMemberError: null,
  pictures: [],
  documents: [],
  deleteFileLoading: false,
  loadingFeeds: false,
  loadedFeeds: false,
  feeds: [],
  mixrFeeds: [],
  groupFeeds: [],
  feedsStats: null,
  newsFeedId: 0,
  selectedNewsFeed: {
    id: '',
    title: '',
    picture: '',
    typeId: '',
    type: ''
  },
  loadingSendMessage: false,
  isMessagePosted: false,
  reactionProcessing: false,
  reactionToProcess: null,
  deleteMessageLoading: false,
  isMessageDeleted: false,
  loadingEditMessage: false,
  isMessageEdited: false,
  usersInFeed: [],
  originMessageId: 0,
  loadingMedias: false,
  userAfterChangedRole: null,
  userRemoved: false,
  message_draft: null,
  serverErrors: null,
  ctas: { new_members_paginated: { loading: false } },
  rating: null
}

export function feedHome(state = initialState, action) {
  const { response } = action

  switch (action.type) {
    case fc.DELETE_FILE_REQUEST:
      return {
        ...state,
        deleteFileLoading: true
      }
    case fc.DELETE_FILE_SUCCESS:
      if (action.response) {
        const { group } = action.response
        return {
          ...state,
          deleteFileLoading: false,
          group: {
            ...state.group,
            ...group
          }
        }
      } else {
        return { ...state }
      }
    case fc.DELETE_FILE_FAILURE:
      return {
        ...state,
        deleteFileLoading: false
      }

    case fc.SELECTED_NEWSFEED:
      return {
        ...state,
        newsFeedId: action.newsFeed.id,
        selectedNewsFeed: {
          ...state.selectedNewsFeed,
          ...action.newsFeed
        }
      }

    case fc.ADD_STAFF_ROLE_REQUEST:
    case fc.REMOVE_STAFF_ROLE_REQUEST: {
      return {
        ...state
      }
    }
    case fc.ADD_STAFF_ROLE_SUCCESS:
    case fc.REMOVE_STAFF_ROLE_SUCCESS: {
      const { scope } = action
      const { user_id, user_group_role } = action.response
      const usersToUpdate = [...state.users]
      const usersInFeedToUpdate = [...state.usersInFeed]
      //for members tab
      for (let i = 0; i < usersToUpdate.length; i++) {
        if (usersToUpdate[i].id == user_id) {
          usersToUpdate[i].role = user_group_role
        }
      }
      //for feeds tab
      if (usersInFeedToUpdate.length > 0) {
        for (let i = 0; i < usersInFeedToUpdate.length; i++) {
          if (usersInFeedToUpdate[i].id == user_id) {
            usersInFeedToUpdate[i].role = user_group_role
          }
        }
      }
      return {
        ...state,

        users:
          scope && scope === 'staff_members'
            ? usersToUpdate.filter((u) => u.role === 'organizer' || u.role === 'co-organizer')
            : [...usersToUpdate],
        usersInFeed: [...usersInFeedToUpdate],
        userAfterChangedRole: { ...action.response }
      }
    }
    case fc.ADD_STAFF_ROLE_FAILURE:
    case fc.REMOVE_STAFF_ROLE_FAILURE: {
      return {
        ...state,
        serverErrors: action.error
      }
    }

    case fc.REMOVE_FROM_GROUP_REQUEST: {
      return {
        ...state,
        userRemoved: false
      }
    }

    case fc.REMOVE_FROM_GROUP_SUCCESS: {
      const { user_id } = action.response

      return {
        ...state,
        users: state.users.filter((u) => u.id != user_id),
        usersInFeed: state.usersInFeed.filter((u) => u.id != user_id),
        userRemoved: true
      }
    }

    case fc.REMOVE_FROM_GROUP_FAILURE: {
      return {
        ...state,
        serverErrors: action.error,
        userRemoved: false
      }
    }

    case fc.GET_FEED_CTA_REQUEST: {
      return {
        ...state
      }
    }
    case fc.GET_FEED_CTA_SUCCESS: {
      return {
        ...state,
        ctas: { ...state.ctas, ...action.response }
      }
    }
    case fc.GET_FEED_CTA_FAILURE: {
      return {
        ...state
      }
    }
    case fc.GET_NEW_MEMBERS_CTA_REQUEST: {
      return {
        ...state,
        ctas: {
          ...state.ctas,
          new_members_paginated: {
            ...state.ctas.new_members_paginated,
            loading: true
          }
        }
      }
    }
    case fc.GET_NEW_MEMBERS_CTA_SUCCESS: {
      const { isPagination } = action
      console.log('isPagination::', isPagination)
      let updatedList = state.ctas.new_members_paginated.new_members || []

      console.log('updatedList1::', updatedList)
      if (isPagination) {
        updatedList = [...updatedList, ...action.response.new_members_paginated.new_members]
      } else {
        updatedList = action.response.new_members_paginated.new_members
      }
      console.log('updatedList2::', updatedList)
      return {
        ...state,
        ctas: {
          ...state.ctas,
          new_members_paginated: {
            ...state.new_members_paginated,
            loading: false,
            new_members: updatedList,
            stats: action.response.new_members_paginated.stats
          }
        }
      }
    }
    case fc.GET_NEW_MEMBERS_CTA_FAILURE: {
      return {
        ...state,
        ctas: {
          ...state.ctas,
          new_members_paginated: {
            ...state.ctas.new_members_paginated,
            loading: false,
            error: action.error
          }
        }
      }
    }

    default:
      return state
  }
}
